import React, { type ComponentProps } from 'react';
import { StyleSheet } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { Container } from '@garnish/core';

export const HowItWorksContainer = (props: HowItWorksContainerProps) => {
  const { children, style } = props;

  return (
    <SafeAreaView edges={['bottom']} style={styles.outerContainer}>
      <Container style={[styles.container, style]} wrapperStyle={styles.container}>
        {children}
      </Container>
    </SafeAreaView>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  outerContainer: {
    flexGrow: 1,
  },
  container: {
    flexGrow: 1,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type HowItWorksContainerProps = ComponentProps<typeof Container>;
